export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: 'Dashboard',
        to: 'Dashboard',
        icon: {
          src: require('@/assets/img/element-4.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
      },
     
      {
        _name: 'CSidebarNavItem',
        name: 'UpdateData',
        to: 'UpdateData',
        icon: {
          src: require('@/assets/img/profile-2user.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
      },
     
      {
        _name: 'CSidebarNavDropdown',
        name: 'Your List',
        icon: {
          src: require('@/assets/img/profile-2user.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
        items: [
          {
            name: 'Customer feedback',
            to: '/VideoList',
            icon: {
              src: require('@/assets/img/profile-2user.png'),
              width: 15,
              height: 15,
              class: 'mr-3'
            },
          },
          {
            name: 'Job Seeker',
            to: '/InterviewCandidateList',
            icon: {
              src: require('@/assets/img/video-square.png'),
              width: 15,
              height: 15,
              class: 'mr-3'
            },
          },
          
         
        
        ]
      },
      
    ]
  },
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: 'Setting',
        to: 'Setting',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Logout',
        to: 'Logout',
      },
    ],
    _style: 'margin-top: auto;', // Pushes the navigation items to the bottom of the sidebar
  }
]